import { Selector } from '@ngxs/store';
import { ReportState } from '@core/store/report/report.state';
import { ReportStatePrototype } from '@core/store/report/report-state-prototype.model';
import { MapItem } from '@capturum/auth';

export class ReportSelectors {
  @Selector([ReportState])
  public static getReportId(state: ReportStatePrototype): string {
    return state.reportId;
  }

  @Selector([ReportState])
  public static getReports(state: ReportStatePrototype): MapItem[] {
    return state.reports;
  }
}
